import SC from 'styled-components'

const ItemWrapper = SC.div`
  width: 226px;
`

export const s = {
  ItemWrapper
}
